<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in showHasPermissionTabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey===item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import { hasPermission } from '@/utils/permission'
import { findCpeSupplierName } from '@/api/cpe_supplier'

export default {
  name: 'ShowCpeSupplierTab',
  data() {
    return {
      activeKey: '',
      allTabs: [
        { routeName: 'cpe_supplier_info', tabName: '基本信息', menu: 'cpe_suppliers/show' },
        { routeName: 'cpe_supplier_models', tabName: 'CPE型号', menu: 'cpe_supplier_models' },
        { routeName: 'cpe_supplier_cpes', tabName: '已划拨CPE列表', menu: 'cpe_supplier_cpes' }
      ],
      showHasPermissionTabs: []
    }
  },
  computed: {
    cpeSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  watch: {
    cpeSupplierId() {
      this.setBreadcrumb()
    }
  },
  created() {
    this.activeKey = this.$route.name
    this.fetchShowHasPermissionTabs()
    this.setBreadcrumb()
  },
  methods: {
    setBreadcrumb() {
      findCpeSupplierName(this.cpeSupplierId).then((res) => {
        if (res.code === 0) {
          this.$store.dispatch('SetDynamicBreadCrumbsPlaceholder', { ':cpe_supplier_name': res.data.name })
        }
      })
    },

    isShowMenu(menu) {
      return hasPermission(menu)
    },

    fetchShowHasPermissionTabs() {
      let isIncludeActiveKey = false

      this.allTabs.forEach((value) => {
        if (this.isShowMenu(value.menu)) {
          this.showHasPermissionTabs.push(value)
          if (value.routeName === this.activeKey) {
            isIncludeActiveKey = true
          }
        }
      })

      if (!isIncludeActiveKey && this.showHasPermissionTabs.length > 0) {
        this.activeKey = this.showHasPermissionTabs[0].routeName
      }
    },

    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
